// extracted by mini-css-extract-plugin
module.exports = {"link":"_8c559fa4c7--link--pLRbq","padding-link-8":"_8c559fa4c7--padding-link-8--a8nw8","link-title":"_8c559fa4c7--link-title--pxXyg","link-count":"_8c559fa4c7--link-count--s7bNu"};